var _rect, _g, _path, _path2, _path3, _path4, _rect2, _g2, _g3, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1055,
    viewBox: "0 0 1920 1055",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    clipPath: "url(#clip0_170_415)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 1920,
    transform: "matrix(-5.98511e-08 -1 -1 3.1924e-08 1920 900)",
    fill: "#131126"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_170_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1900.77 763.478C2062.4 688.745 2104.95 514.096 1995.82 373.388L1489.04 -280C1379.9 -420.708 1160.4 -474.191 998.77 -399.458L81.0044 24.8882C-80.626 99.6211 -123.181 274.27 -14.0452 414.978L492.736 1068.37C601.872 1209.07 821.372 1262.56 983.002 1187.82L1900.77 763.478Z",
    fill: "url(#paint0_radial_170_415)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter1_f_170_415)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1175.1 1231.13C1303.12 1268.14 1454.03 1200.93 1512.18 1081.03L1888.49 305.003C1946.63 185.096 1889.99 57.8912 1761.97 20.884L661.34 -297.278C533.319 -334.285 382.402 -267.081 324.257 -147.174L-52.0515 628.85C-110.197 748.757 -53.5521 875.962 74.4682 912.969L1175.1 1231.13Z",
    fill: "url(#paint1_radial_170_415)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter2_f_170_415)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1669.53 1181.43C1797.55 1218.43 1948.47 1151.23 2006.61 1031.32L2297.29 431.884C2355.43 311.977 2298.79 184.772 2170.77 147.765L1298.38 -104.421C1170.36 -141.428 1019.44 -74.2239 961.294 45.6837L670.615 645.121C612.47 765.029 669.115 892.233 797.135 929.241L1669.53 1181.43Z",
    fill: "url(#paint2_radial_170_415)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter3_f_170_415)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M477.092 1143.44C678.884 1201.77 916.767 1095.84 1008.42 906.833L1148.3 618.361C1239.96 429.356 1150.67 228.85 948.878 170.518L422.146 18.2537C220.354 -40.0789 -17.5294 65.8516 -109.181 254.856L-249.067 543.328C-340.719 732.332 -251.432 932.839 -49.6402 991.171L477.092 1143.44Z",
    fill: "url(#paint3_radial_170_415)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter4_f_170_415)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.35 960.104C949.396 1136.75 878.289 1332.97 874.479 1408.99C883.501 1562.94 914.802 1801.27 967.832 1523.01C1034.12 1175.19 1279.49 1115.75 1718.36 800.785C2069.46 548.811 1890.75 488.958 1757.51 490.528L1525.13 584.255C1523.68 635.935 1457.3 783.455 1203.35 960.104Z",
    fill: "url(#paint4_radial_170_415)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 520,
    width: 1920,
    height: 380,
    fill: "url(#paint5_linear_170_415)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_170_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1461.16 194.233C1487.54 208.13 1497.66 240.782 1483.76 267.162C1469.86 293.542 1437.21 303.662 1410.84 289.765C1384.46 275.868 1374.34 243.218 1388.23 216.837C1402.13 190.456 1434.78 180.336 1461.16 194.233Z",
    fill: "url(#paint6_radial_170_415)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_170_415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 509.5,
    cy: 164.5,
    r: 37.5,
    fill: "url(#paint7_radial_170_415)",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M659.191 771.856C670.044 915.749 570.412 1041.79 436.655 1053.37C302.895 1064.95 185.664 957.694 174.809 813.801C163.956 669.906 263.588 543.869 397.345 532.285C531.105 520.703 648.336 627.963 659.191 771.856Z",
    fill: "url(#paint8_radial_170_415)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_170_415",
    x: -209.672,
    y: -568.344,
    width: 2401.12,
    height: 1925.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.5618,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_170_415",
    x: -195.548,
    y: -428.09,
    width: 2227.53,
    height: 1790.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_170_415",
    x: 527.118,
    y: -235.232,
    width: 1913.67,
    height: 1547.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_170_415",
    x: -405.732,
    y: -118.416,
    width: 1710.7,
    height: 1398.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_170_415",
    x: 825.479,
    y: 441.498,
    width: 1146.66,
    height: 1258.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_170_415",
    x: 1378,
    y: 188,
    width: 115.999,
    height: 115.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_170_415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_170_415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_170_415",
    x: 462,
    y: 117,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_170_415"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(892.994 518.544) rotate(-152.302) scale(854.905 758.255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39CABB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1361.74 374.362) rotate(158.742) scale(744.056 626.949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1862.76 459.445) rotate(158.742) scale(635.492 535.472)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.972 748.161) rotate(-142.019) scale(567.225 551.465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F257A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1512.25 817.377) rotate(130.051) scale(514.001 468.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_415",
    x1: 960,
    y1: 520,
    x2: 960,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1478.78 229.751) rotate(163.847) scale(106.234 96.5434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6151C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#A14BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#CBCAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(504.188 121.687) rotate(87.7365) scale(79.1243 932.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B6471"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_170_415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(457.67 527.059) rotate(115.684) scale(607.284 581.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#FF6F6F",
    stopOpacity: 0.536826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550999,
    stopColor: "#D427FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 1920,
    fill: "white",
    transform: "matrix(-5.98511e-08 -1 -1 3.1924e-08 1920 900)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/mainBg.b92b31cabd1e8e424eb4a9466eabc7ad.svg";
export { ForwardRef as ReactComponent };